import { Type } from 'class-transformer';
import { IsNotEmpty, IsOptional, IsString, ValidateNested } from 'class-validator';

import BaseIvrNode, { EMPTY_NEXT_ID_MESSAGE } from './baseIvrNode';

export default class NumberMatchNode extends BaseIvrNode {
  @IsString()
  @IsNotEmpty({ message: EMPTY_NEXT_ID_MESSAGE })
  defaultNextId: string;

  @ValidateNested({ each: true })
  @Type(() => NumberMatch)
  numberMatchers: NumberMatch[];
}

class NumberMatch {
  @IsString()
  @IsNotEmpty({ message: 'Please enter a valid regular expression' })
  pattern: string;

  @IsString()
  @IsOptional()
  nextId?: string;
}
